export const PUBLISHER_FORECAST_PERMISSION_NAME = 'publisher.deal.forecast';